module.exports = __webpack_public_path__ + "static/media/navigationGhost.5d9d9f23.png";